/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CandidateFileTagUpdatePathParams,
	CandidateFileTagUpdateRequest,
	CandidateFileTagUpdateResponse,
} from '../types/CandidateFileTagUpdate'

/**
 * PUT /candidates/:candidateId/files/:fileId/tag
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateFileTagController.php CandidateFileTagController::update
 */
export async function candidateFileTagUpdate(
	candidateId: CandidateFileTagUpdatePathParams['candidateId'],
	fileId: CandidateFileTagUpdatePathParams['fileId'],
	data: CandidateFileTagUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateFileTagUpdateResponse>> {
	return axiosInstance.put(`/candidates/${candidateId}/files/${fileId}/tag`, data, config)
}
